import { ConfigurationChangeModel, ConfigurationChangeState } from '@/types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const state: ConfigurationChangeState = {
  configurationChange: {} as ConfigurationChangeModel,
  isLoading: false,
  error: false,
  errorMessage: ''
};

const namespaced: boolean = true;

export const configurationChange = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
